import React from "react";
import "../radio-page-helsinki/radio-page.m.css";
import { useDispatch } from "react-redux";
import { RADIOT_TURKU } from "../../../store/actions";

const RadioPageTurku = () => {
  const dispatch = useDispatch();
  return (
    <div styleName="radio-container">
      <div styleName="radio-wrapper">
        <div>
          <h2>Radio Dei Turku</h2>
          <p>Enämmä toivoo</p>
        </div>
        <div styleName="mhz">
          <i className="ri-radio-fill"></i>
          <h2>Turku / 107.3 MHz</h2>
        </div>
      </div>
      <div styleName="container">
        <div styleName="radio-img">
          <img src="https://fiare-stg-thumbor.assettype.com/dei/2025-03-27/lxnughoy/turku.png" />
        </div>
        <div styleName="overlay">
          <h2>Radio Dei Turku</h2>
          <p> Uskoa, toivoa ja yhteyttä.</p>

          <div styleName="kuuntele-radio">
            <i className="ri-radio-fill ri-3x"></i>
            <button
              onClick={() => {
                dispatch({
                  type: RADIOT_TURKU,
                  isRadiotTurkuClicked: true,
                });
              }}
            >
              Kuuntele
            </button>
          </div>
        </div>
      </div>
      <div styleName="kanavan-wrapper">
        <div styleName="kanavan-esittely">
          <h2>Radio Dei Turku</h2>

          <p>
            Radio Dei Turku on Dein lounaisin taajuus. Alueella voi kuunnella valtakunnallisen radiolähetyksen ohella
            paikallisia lähetyksiä ajoitan maanantain klo 18-21 välillä.
          </p>
          <h2>Kuuluvuusalue</h2>
          <p>
            Turun taajuus kuuluu hyvin Kortesjärvelle, Kuortaneelle, Sydänmaalle, Koskenkorvaan, Isokyröön ja Vimpeliin,
            Alajärvelle, Vöyriin. Varsinkin autolla ja maastosta riippuen se voi kuulua hyvällä radiolla myös Kurikkaan,
            Jurvaan, Laihialle, Vähäkyröön, Oravaisille ja Uusikaarepyyhyn saakka.
          </p>
        </div>
        {/* <div styleName="kanavan-tiedot">
        <h2>Kanavan Tiedot</h2>
          <div styleName="kanavan-tiedot-info">
            <p styleName="first-para">Taajuus: </p>
            <p> 89.0 MHz / 101.9 MHz</p>
          </div>
          <div styleName="kanavan-tiedot-info">
            <p styleName="first-para">Taajuus: </p>
            <p> 89.0 MHz / 101.9 MHz</p>
          </div>
          <div styleName="kanavan-tiedot-info">
            <p styleName="first-para">Taajuus: </p>
            <p> 89.0 MHz / 101.9 MHz</p>
          </div>
        </div> */}
      </div>
      <div styleName="radio-wrapper-lower">
        <div styleName="radio-lower-info">
          <h2>Kuuluvuusaluekartta</h2>
          <p>
            Keltainen väri kuvastaa virallista kuuluvuusaluetta. Punainen alue on lähes yhtä hyvä. Sinisellä alueella
            Dei kuuluu hyvin autossa, paikasta ja radiosta riippuen myös muulla tavoin.
          </p>
        </div>
        <div styleName="location-img">
          <img src="https://s3-alpha-sig.figma.com/img/9fb7/a7cb/822718f6c64c40d29ce2158f00a56edc?Expires=1744588800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=T-BadTz2YXpRgop1crGr-XJKxEL~20DYarl0etBh5lRfRI9ndCFR47i19fY~Wi9rq6OF6scCsrz7whA5lZfO7LXin5jsR4wHMmMuAnfr59uBM6lTrrapScZ810kAkG71v4z6O-t1djcCc593Zii~DT-4WDUmifTfaiCiuLLSV1Bx~Rns0tNo1rL0p3WKWIVtiJmn8QCozmzctvTXTADjY9Zz7DFH1pMf2VUmpeDAdKwCQLXjFQl3FJThnKSBNaZLJuoucPGYcHO64NB8dRWedYN36HYluEhPzR4Te0e198ysgS9VYD-iknc~q313pY9ThQy4lJqka387A8-yf8XcFw__" />
        </div>
      </div>
    </div>
  );
};
export { RadioPageTurku };
